<template>
  <div class="com-box">
    <div class="card">
      <img class="left" src="https://img3.quanyou.com.cn/joyNew/group1/M00/1C/EA/rB8LrmUvgCmAKWQZAAECFkWWr5w518.png" alt="" />
      <div class="right">
        <div class="title-1">暂无门店名称</div>
        <div class="title-2">暂无门店地址</div>
        <div class="bottom">
          <img class="icon" src="https://img3.quanyou.com.cn/joyNew/group1/M00/1C/EA/rB8LrmUvgSaAJVDcAAAEPbvLynI460.png" alt="" />
          <div class="btn">打电话</div>
        </div>
      </div>
    </div>
    <img class="more" src="https://img3.quanyou.com.cn/joyNew/group1/M00/1C/EB/rB8LrmUvhMSADNXFAAAoSaL0T6w877.png" alt="">
  </div>
</template>

<script>
export default {
 
}
</script>

<style lang="stylus" scoped>
  .com-box {
    overflow: hidden;
    width: 100%;
    height: 330px;
    background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1D/92/rB8LrWU3ONyASqv-AAE7tqELoko787.png');
    background-size: 100% 100%;
    .card {
      display: flex;
      width: 307px;
      height: 142px;
      box-shadow: 0px 3px 10px 0px rgba(196,99,3,0.7);
      border-radius: 5px;
      margin: auto;
      margin-top: 108px
      background: linear-gradient(0deg, #FFF3DF, #FFFCF6);
      padding: 13px;
      box-sizing: border-box;

      .left {
        width: 85px;
        height: 116px;
      }
      .right {
        width: 207px;
        margin-left: 13px;
        margin-top: 4px;
        .title-1 {
          color: #E24409;
          font-size: 15px;
          font-weight: bold;
        }
        .title-2 {
          color: #BC481C;
          font-size: 14px;
          margin-top: 12px;
        }
        .bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 14px;
          .icon {
            width: 80px;
            height: 14px;
          }
          .btn {
            width: 78px;
            height: 43px
            color: #fff;
            font-size: 14px;
            text-align: center;
            line-height: 36px;
            background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1C/EB/rB8LrmUvg1uAWRORAAAfnOsZFXo353.png');
            background-size: 100% 100%;
          }
        }
      }
    }
    .more {
      display: block
      width: 111px;
      height: 36px
      margin: auto;
      margin-top: 8px;
    }
  }
</style>